import { createApi } from "@reduxjs/toolkit/query/react";

import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import { transformResponseHandler } from "utils/transformResponseHandler";

import { customFetchBase } from ".";

const invesmentsApi = createApi({
  reducerPath: REDUCER_PATHS.INVESMENTS,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    propertyInvesmentsList: builder.query({
      query: (data) => ({
        url: `${apiConfig.INVESMENTS}?page=${data?.page}&pageSize=${data?.pageSize}&searchText=${data.searchText}&sortColumn=${data.sortColumn}&sortDirection=${data.sortDirection}`,
        method: "GET",
      }),
      providesTags: ["propertyInvesmentsList"],
    }),
    propertyInvesmentsUserList: builder.query({
      query: (data) => ({
        url: `${apiConfig.INVESMENTS_USER}/?page=${data?.page}&pageSize=${data?.pageSize}&searchText=${data.searchText}&sortColumn=${data.sortColumn}&sortDirection=${data.sortDirection}&propertyInvesmentsId=${data?.propertyInvesmentsId}`,
        method: "GET",
      }),
      providesTags: ["propertyInvesmentsList"],
    }),
    editPropertyInvesmentsList: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.INVESMENTS}/${data?.depositId}`,
        body: data?.body,
        method: "PUT",
      }),
      invalidatesTags: ["propertyInvesmentsList"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    propertyInvesmentsListChangeStatus: builder.mutation({
      query: (data) => ({
        url: apiConfig.INVESMENTS,
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: ["propertyInvesmentsList"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    propertyInvesmentsListDelete: builder.mutation({
      query: (data) => ({
        url: apiConfig.INVESMENTS,
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: ["propertyInvesmentsList"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    addPropertyInvesmentsList: builder.mutation({
      query: (data) => ({
        url: apiConfig.INVESMENTS,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["propertyInvesmentsList"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    propertyInvesmentSummaryList: builder.query({
      query: (data) => {
        const params = new URLSearchParams();
        if (data?.propertyId) params.append("propertyId", data.propertyId);
        if (data?.investmentAmount)
          params.append("investmentAmount", data.investmentAmount);

        return {
          url: `${apiConfig.INVESMENTS_SUMMARY}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["propertyInvesmentsList"],
    }),
    propertyInvestmentUpdateDetails: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.INVESTMENT_UPDATE_DETAILS}`,
        method: "PUT",
        body: data,
      }),
      providesTags: ["propertyInvesmentsList"],
    }),
    propertyInvesmentsDetails: builder.query({
      query: (data) => ({
        url: `${apiConfig.INVESMENTS_DETAIL}/${data?.investmentId}`,
        method: "GET",
      }),
      providesTags: ["propertyInvesmentsList"],
    }),
    propertyInvesmentsDownload: builder.mutation({
      query: (data) => {
        const params = new URLSearchParams();

        if (data.filter) params.append("filter", data.filter);
        if (data.column) params.append("column", data.column);

        return {
          url: `${apiConfig.INVESMENTS_DOWNLOAD}/${
            data.type
          }?${params.toString()}`,
          method: "GET",
        };
      },
      invalidatesTags: ["propertyInvesmentsList"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
  }),
});

export const {
  useAddPropertyInvesmentsListMutation,
  useEditPropertyInvesmentsListMutation,
  useLazyPropertyInvesmentsDetailsQuery,
  useLazyPropertyInvesmentsListQuery,
  useLazyPropertyInvesmentsUserListQuery,
  useLazyPropertyInvesmentSummaryListQuery,
  usePropertyInvesmentsDownloadMutation,
  usePropertyInvesmentsListChangeStatusMutation,
  usePropertyInvesmentsListDeleteMutation,
  usePropertyInvestmentUpdateDetailsMutation,
} = invesmentsApi;

export default invesmentsApi;
